import './App.css';
import { useState } from 'react';
import { menuData } from './menuData';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [cart, setCart] = useState({});

  const addToCart = (item) => {
    setCart(prev => {
      const currentQty = prev[item.name] ? prev[item.name].qty : 0;
      return {
        ...prev,
        [item.name]: { ...item, qty: currentQty + 1 }
      };
    });
  };

  const removeFromCart = (item) => {
    setCart(prev => {
      const currentQty = prev[item.name] ? prev[item.name].qty : 0;
      if (currentQty <= 1) {
        const newCart = { ...prev };
        delete newCart[item.name];
        return newCart;
      }
      return {
        ...prev,
        [item.name]: { ...item, qty: currentQty - 1 }
      };
    });
  };

  const getTotal = () => {
    return Object.values(cart).reduce((total, item) => {
      const price = parseInt(item.price.toString().replace(/\D/g, '')) || 0;
      return total + (price * item.qty);
    }, 0);
  };

  const sendOrderToWhatsApp = () => {
    const orderItems = Object.values(cart);
    if (orderItems.length === 0) return;

    let message = "Hello Coffea Hisar! I would like to place an order:\n\n";
    orderItems.forEach(item => {
      message += `${item.name} x ${item.qty} = ₹${parseInt(item.price.toString().replace(/\D/g, '')) * item.qty}\n`;
    });
    message += `\n*Total Bill: ₹${getTotal()}*`;

    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/919992400095?text=${encodedMessage}`, '_blank');
  };

  const totalItems = Object.values(cart).reduce((acc, item) => acc + item.qty, 0);

  return (
    <>
      <header className="nav">
        <div className="top-bar">
          <div className="container center">
            GST: HAKIKAT - 06AQSPH3731P1ZA
          </div>
        </div>
        <div className="container nav__content">
          <div className="brand">
            <img className="nav__logo" src={process.env.PUBLIC_URL + '/logo.png'} alt="Coffea logo" />
            <span>Coffea Hisar</span>
          </div>
          <button
            className={`menu-toggle ${menuOpen ? 'is-open' : ''}`}
            aria-expanded={menuOpen}
            aria-label="Toggle menu"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="menu-toggle__bar" />
            <span className="menu-toggle__bar" />
            <span className="menu-toggle__bar" />
          </button>
          <nav className={`menu ${menuOpen ? 'menu--open' : ''}`}>
            <a href="#about" onClick={() => setMenuOpen(false)}>About</a>
            <a href="#menu" onClick={() => setMenuOpen(false)}>Menu</a>
            <a href="#gallery" onClick={() => setMenuOpen(false)}>Gallery</a>
            <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
          </nav>
        </div>
      </header>

      <main>
        <section className="hero" style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/coffeahall.jpg)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}>
          <div
            className="hero__bg"

          />
          <div className="hero__overlay" />
          <div className="container hero__content">
            <p className="eyebrow">Premium Coffee Experience</p>
            <h1>Coffea Hisar</h1>
            <p className="lede">Coffea Hisar: The Heart of Your Brew </p>
            <div className="actions">
              <a className="btn btn--primary" href="tel:9992400095">Call Us</a>
              <a className="btn btn--ghost" href="https://maps.app.goo.gl/sJua4CQjG257FsyJ6?g_st=iw" target="_blank" rel="noopener noreferrer">Visit Us</a>
            </div>
          </div>
        </section>

        <section
          id="about"
          className="section"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/bg-all.jpg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#12623A',
          }}
        >
          <div className="section__overlay" />
          <div className="container grid grid--2">
            <div className="card">
              <h2 className="section__title">Meet Our Cafe</h2>
              <p>Where coffee meets craft. Years of passion distilled into every cup. We pair great brews with comforting bites for moments worth savoring.</p>
              <a className="btn btn--link" href="#about-more">Read More</a>
            </div>
            <div className="media">
              <img src={process.env.PUBLIC_URL + '/coffeaenter.jpg'} alt="Coffea Storefront" />
            </div>
          </div>
        </section>

        <section id="menu" className="section section--surface">
          <div className="container">
            <h2 className="section__title center">Menu</h2>
            <div className="menu-list">
              {menuData.map((category, index) => (
                <div key={index} className="menu-category">
                  <h3>{category.category}</h3>
                  <ul>
                    {category.items.map((item, idx) => {
                      const qty = cart[item.name] ? cart[item.name].qty : 0;
                      return (
                        <li key={idx} style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <span className="item">{item.name}</span>
                            <span className="price">{item.price}</span>
                          </div>
                          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '4px' }}>
                            {qty > 0 ? (
                              <>
                                <button
                                  onClick={() => removeFromCart(item)}
                                  className="btn--small"
                                  style={{ padding: '2px 8px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                >-</button>
                                <span style={{ fontWeight: 'bold' }}>{qty}</span>
                                <button
                                  onClick={() => addToCart(item)}
                                  className="btn--small"
                                  style={{ padding: '2px 8px', background: '#2ecc71', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                >+</button>
                              </>
                            ) : (
                              <button
                                onClick={() => addToCart(item)}
                                className="btn--small"
                                style={{ padding: '4px 12px', background: 'var(--brand)', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem' }}
                              >
                                Add +
                              </button>
                            )}
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                  {category.addOns && (
                    <div className="add-ons" style={{ marginTop: '1rem', borderTop: '1px dashed #eee', paddingTop: '0.5rem' }}>
                      <h4 style={{ fontSize: '0.9rem', color: '#888', marginBottom: '0.5rem' }}>YOUR CHOICE (ADD-ONS)</h4>
                      <ul>
                        {category.addOns.map((addOn, idx) => {
                          const qty = cart[addOn.name] ? cart[addOn.name].qty : 0;
                          return (
                            <li key={idx} style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <span className="item">{addOn.name}</span>
                                <span className="price">{addOn.price}</span>
                              </div>
                              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                {qty > 0 ? (
                                  <>
                                    <button onClick={() => removeFromCart(addOn)} style={{ padding: '2px 8px', background: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px' }}>-</button>
                                    <span>{qty}</span>
                                    <button onClick={() => addToCart(addOn)} style={{ padding: '2px 8px', background: '#2ecc71', color: 'white', border: 'none', borderRadius: '4px' }}>+</button>
                                  </>
                                ) : (
                                  <button onClick={() => addToCart(addOn)} style={{ padding: '4px 12px', background: '#888', color: 'white', border: 'none', borderRadius: '4px', fontSize: '0.8rem' }}>Add</button>
                                )}
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Floating Cart / Bill Summary */}
        {totalItems > 0 && (
          <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            background: 'white',
            padding: '20px',
            borderRadius: '12px',
            boxShadow: '0 5px 20px rgba(0,0,0,0.3)',
            maxWidth: '350px',
            width: '90%',
            zIndex: 1000,
            border: '2px solid var(--brand)'
          }}>
            <h3 style={{ margin: '0 0 10px', color: '#333' }}>Order Summary</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 10px', maxHeight: '200px', overflowY: 'auto' }}>
              {Object.values(cart).map((item, idx) => (
                <li key={idx} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px', fontSize: '0.9rem', color: '#555' }}>
                  <span>{item.name} x {item.qty}</span>
                  <span>₹{parseInt(item.price.toString().replace(/\D/g, '')) * item.qty}</span>
                </li>
              ))}
            </ul>
            <div style={{ borderTop: '1px solid #ddd', paddingTop: '10px', display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', color: '#333' }}>
              <span>Total:</span>
              <span>₹{getTotal()}</span>
            </div>
            <button
              onClick={sendOrderToWhatsApp}
              style={{
                width: '100%',
                marginTop: '15px',
                padding: '12px',
                background: '#25D366',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontWeight: 'bold',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px'
              }}
            >
              🚀 Send Order on WhatsApp
            </button>
          </div>
        )}

        <section id="mission" className="section">
          <div className="container grid grid--2">
            <div>
              <h2 className="section__title">Mission & Vision</h2>
              <p>To craft memorable coffee experiences and foster a community that savors quality in every sip.</p>
              <ul className="checks">
                <li>Freshly brewed beans</li>
                <li>Chef-curated bites</li>
                <li>Warm, welcoming spaces</li>
              </ul>
            </div>
            <div className="media">
              <img src="https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?q=80&w=1200&auto=format&fit=crop" alt="Cafe interior" />
            </div>
          </div>
        </section>

        <section
          id="contact"
          className="section section--surface"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/bg-all.jpg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#12623A',
          }}
        >
          <div className="section__overlay" />
          <div className="container">
            <div className="contact-wrapper">
              <h2 className="section__title center">Get in Touch</h2>
              <p className="center contact-intro">We'd love to hear from you! Visit us or reach out through any of these channels.</p>
              <div className="contact-grid">
                <div className="contact-card">
                  <h3>📞 Call Us</h3>
                  <p><a href="tel:9992400095">9992400095</a></p>
                </div>
                <div className="contact-card">
                  <h3>📧 Email</h3>
                  <p><a href="mailto:coffeahisar@gmail.com">coffeahisar@gmail.com</a></p>
                </div>
                <div className="contact-card">
                  <h3>💬 WhatsApp</h3>
                  <p>Chat with us on WhatsApp</p>
                  <a className="btn btn--primary" href="https://wa.me/919992400095?text=Hello%20Coffea%20Hisar" target="_blank" rel="noopener noreferrer">Open WhatsApp</a>
                </div>
                <div className="contact-card">
                  <h3>📍 Visit Us</h3>
                  <p>Old Courts Commercial Complex<br />Lajpat Nagar, Hisar<br />Haryana 125001</p>
                  <p className="hours">Open daily: 10:00 AM — 11:00 PM</p>
                  <a className="btn btn--primary" href="https://maps.app.goo.gl/sJua4CQjG257FsyJ6?g_st=iw" target="_blank" rel="noopener noreferrer">Get Directions</a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="gallery" className="gallery section">
          <div className="container">
            <h2 className="section__title">Coffea — Cafe Areas</h2>
            <div className="gallery__grid">
              <figure className="gallery__item">
                <img src={process.env.PUBLIC_URL + '/cefe11.jpg'} alt="Cafe seating area" />
              </figure>
              <figure className="gallery__item">
                <img src={process.env.PUBLIC_URL + '/coffeahall.jpg'} alt="Coffee hall" />
              </figure>
              <figure className="gallery__item">
                <img src={process.env.PUBLIC_URL + '/coffee-bg.jpg'} alt="Coffee hall" />
              </figure>
              <figure className="gallery__item">
                <img src={process.env.PUBLIC_URL + '/girlcup.png'} alt="Coffee hall" />
              </figure>
              <figure className="gallery__item">
                <img src={process.env.PUBLIC_URL + '/coffe1.jpg'} alt="Coffee hall" />
              </figure>
              <figure className="gallery__item">
                <img src={process.env.PUBLIC_URL + '/coffe2.jpg'} alt="Coffee hall" />
              </figure>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container footer__grid">
          <div>
            <h3>Useful Links</h3>
            <ul className="links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#menu">Menu</a></li>
              <li><a href="#gallery">Gallery</a></li>
            </ul>
          </div>
          <div>
            <h3>Community</h3>
            <ul className="links">
              <li><a href="#facebook">Facebook</a></li>
              <li><a href="#instagram">Instagram</a></li>
              <li><a href="#x">X</a></li>
              <li><a href="#linkedin">LinkedIn</a></li>
            </ul>
          </div>
          <div>
            <h3>Contact</h3>
            <ul className="links">
              <li><a href="tel:9992400095">Phone: 9992400095</a></li>
              <li><a href="mailto:coffeahisar@gmail.com">Mail: coffeahisar@gmail.com</a></li>
              <li><a href="https://maps.app.goo.gl/sJua4CQjG257FsyJ6?g_st=iw" target="_blank" rel="noopener noreferrer">Address: Lajpat Nagar, Hisar</a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">2025. Coffea Hisar - Premium Coffee</div>
      </footer>
    </>
  );
}

export default App;
